import styled from "styled-components";
import { styledByTheme } from "../../../themes/architecture/styled-by-theme";
import { CssRule } from "../../../themes/architecture/css-helpers/css-rule";

const BalanceValuePrimaryDefaultBox = styled.span`
    width: 100%;
    font-size: 2.6rem;
    font-weight: 800;
    text-align: center;
    color: ${({theme}) => theme.colors.userMenuBalanceColor };
    &:after {
        content: "";
        display: block;
        width: 100%;
        margin: 0.5rem 0 1rem 0;
        border-top: none;
        border-bottom: 1px solid ${({theme}) => theme.colors.userMenuBalanceBorder };
        ${CssRule.For.mobile.build()} &{
            display: none;
        }
    }
`;

const BalanceValuePrimaryCasino777Box = styled(BalanceValuePrimaryDefaultBox)`
    /* 777 */
    text-shadow: 3px 3px 0 ${({theme}) => theme.colors.bodyText}, 0 0 0 ${({theme}) => theme.colors.bodyText}, 1px 1px 0 ${({theme}) => theme.colors.bodyText}, 2px 2px 0 ${({theme}) => theme.colors.bodyText}, 0 0 0 ${({theme}) => theme.colors.bodyText};
    -webkit-text-stroke-width: 1px;
    -webkit-text-stroke-color: ${({theme}) => theme.colors.bodyText};
    &:after {
        height: 2px;
        background-image: url("${({theme}) => theme.images.spriteSheet.toString()}");
        background-position: -184px -733px;
        border: none;
    }
`;

export const BalanceValuePrimaryBox = styledByTheme(BalanceValuePrimaryDefaultBox)
    .forCasino777(BalanceValuePrimaryCasino777Box)
    .apply()
